<template>
  <div>
    <load-profile />
    <!-- <b-card>
      <b-card-text class="mb-2">
        <p style="font-size: 18px; font-weight: bold">
          {{ $t("general.chat_ui") }}
        </p>

        class="compact-card"
      </b-card-text> -->
    <b-card>
      <b-card-text class="mb-2">
        <h5 v-if="!isIntegration" class="text-warning">
          <feather-icon icon="AlertCircleIcon" size="22" />
          {{ $t("general.scriptNotInstall") }}
        </h5>
        <p style="font-size: 18px; font-weight: bold">
          {{ $t("general.plugin") }}
        </p>
        <p class="mt-2">
          {{ $t("general.integrationInstruction") }}
        </p>
      </b-card-text>
      <b-form-group>
        <b-form-textarea v-model="script" disabled :rows="3" :max-rows="40" />
        <div class="float-right pt-1">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            class="mr-1"
            variant="primary"
            @click="sendInstruction"
          >
            {{ $t("button.sendInstruction") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            @click="copy(script)"
          >
            {{ $t("button.copy") }}
          </b-button>
        </div>
        <p class="pt-5" style="font-size: 18px; font-weight: bold">
          {{ $t("general.webView") }}
        </p>
        <b-form-textarea v-model="webView" disabled />
        <div class="float-right pt-1">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            class="mr-1"
            variant="primary"
            @click="sendWebViewInstruction"
          >
            {{ $t("button.sendInstruction") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            @click="copy(webView)"
          >
            {{ $t("button.copy") }}
          </b-button>
        </div>
      </b-form-group>
    </b-card>
    <!-- </b-card> -->

    <b-card>
      <p class="pt-9" style="font-size: 18px; font-weight: bold">
        {{ $t("general.api_credentials") }}
      </p>
      <div class="row">
        <b-form-group class="col-md-4">
          <label>
            {{ $t("general.merchantId") }}
          </label>

          <div class="input-group">
            <b-form-input v-model="merchId" disabled />
            <b-input-group-append>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="primary"
                @click="copy(merchId)"
              >
                {{ $t("button.copy") }}
              </b-button>
            </b-input-group-append>
          </div>
        </b-form-group>
        <b-form-group class="col-md-4">
          <label>
            {{ $t("general.appSecret") }}
          </label>
          <div class="input-group">
            <b-form-input v-model="appSecret" disabled />
            <b-input-group-append>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="primary"
                @click="copy(appSecret)"
              >
                {{ $t("button.copy") }}
              </b-button>
            </b-input-group-append>
          </div>
        </b-form-group>
        <b-form-group class="col-md-4">
          <label>
            {{ $t("general.appId") }}
          </label>
          <div class="input-group">
            <b-form-input v-model="appId" disabled />
            <b-input-group-append>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="primary"
                @click="copy(appId)"
              >
                {{ $t("button.copy") }}
              </b-button>
            </b-input-group-append>
          </div>
        </b-form-group>
      </div>
    </b-card>

    <b-card>
      <p class="pt-9" style="font-size: 18px; font-weight: bold">
        {{ $t("general.configuration") }}
      </p>
      <configuration v-if="integration" :data="integration" />
    </b-card>

    <!-- <b-card>
      <p class="pt-9" style="font-size: 18px; font-weight: bold">
        {{ $t("general.partnerConfiguration") }}
      </p>
      <partner-config v-if="chatPartnerConfig" :data="chatPartnerConfig" />
    </b-card> -->

    <send-instruction-modal ref="sendInstructionModal" />
    <send-web-view-instruction-modal ref="sendWebViewInstructionModal" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Repository from "@/repositories/RepositoryFactory";
import SendInstructionModal from "./SendInstructionModal.vue";
import SendWebViewInstructionModal from "./SendWebViewInstructionModal.vue";
import Configuration from "./Configuration.vue";
import PartnerConfig from "./PartnerConfiguration.vue";

const IntegrationRepository = Repository.get("integration");

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    ToastificationContent,
    SendInstructionModal,
    SendWebViewInstructionModal,
    Configuration,
    PartnerConfig,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      merchId: "",
      appId: "",
      appSecret: "",
      script: "",
      webView: "",
      isIntegration: true,
      integration: null,
      loading: false,
      chatPartnerConfig: null,
    };
  },
  computed: {
    MAX_USER_SESSION_EXPIRES_IN() {
      return 10080;
    },
  },
  mounted() {
    this.show();
  },
  methods: {
    show() {
      this.loading = true;
      IntegrationRepository.show()
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.merchId = data.id;
            this.webView = data.webView;
            this.appSecret = data.appSecret;
            this.appId = data.appId;
            this.script = data.script;
            this.isIntegration = data.isIntegration;
            this.integration = {
              ...data.integration,
              userSessionExpiresIn:
                data.integration.userSessionExpiresIn / 1000 / 60,
            };
            if (data.chatPartnerConfig) {
              this.chatPartnerConfig = { ...data.chatPartnerConfig };
            }
          }
        })
        .catch()
        .then(() => {
          this.loading = false;
        });
    },
    copy(text) {
      this.$copyText(text).then(
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t("general.copied"),
              icon: "CopyIcon",
            },
          });
        },
        (e) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t("general.cannotCopy"),
              icon: "AlertCircleIcon",
            },
          });
        }
      );
    },
    sendInstruction() {
      this.$refs.sendInstructionModal.show();
    },
    sendWebViewInstruction() {
      this.$refs.sendWebViewInstructionModal.show();
    },
  },
  setup() {
    const permissionType = "merchant-integration";

    return { permissionType };
  },
};
</script>

<style scoped>
.compact-card {
  margin: 1rem 0;
  border: 1px solid rgba(47, 47, 47, 0.1);
  .card-body {
    /* padding: 1rem; */
  }
}
</style>
